import "../../assets/css/uniqueDocsByClient/UniqueDocsByClient.css"
import info from "../../assets/images/info.svg"

import countryInformation from "../../assets/jsonData/countryInformation.json"

import { Accordion, Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap"

import { useAuth } from "../../context/auth-user"
import { useUniqueDocs } from "./hooks/useUniqueDocs"


const TableHeader = () => {
    return (
        <div className="tableHeader">
            <div className="column">
                <span>Document name</span>
            </div>

            <div className="column">
                <span>Periodicity</span>

                <OverlayTrigger placement="top"
                    overlay={<Tooltip id="periodicityTooltip" style={{ position: "fixed" }}>
                        The periodicity
                        <br />
                        is managed monthly
                        <br />
                        <br />
                        0 = Document that is
                        <br />
                        only requested once
                    </Tooltip>}>

                    <img src={info} alt="Prodensa Supplier" />
                </OverlayTrigger>
            </div>

            <div className="column">
                <span>Country</span>
            </div>

            <div className="column">
                <span>Type of person</span>
            </div>
            
            <div className="column">
                <span>Document disclaimer</span>
            </div>

            <div className="column">
                <span>Url to download document</span>
            </div>
            
            <div className="column slideOption">
                <span>Optional</span>
            </div>

            <div className="column slideOption">
                <span>Required</span>
            </div>
        </div>
    )
}

const DocumentRow = ({ doc, onDocumentChange }) => {
    return (
        <div className="tableRow">
            <div className="inputContainer">
                <input
                    type="text"
                    placeholder="Document name"
                    value={doc.documentName}
                    onChange={(e) => onDocumentChange(doc._id, "documentName", e.target.value)}
                />
            </div>

            <div className="inputContainer periodicity">
                <input
                    type="number"
                    value={doc.periodicity ?? ""}
                    onChange={(e) => {
                        const raw = e.target.value
                        onDocumentChange(doc._id, "periodicity", raw === "" ? "" : Math.max(0, Math.round(Number(raw))))
                    }}
                    onBlur={(e) => {
                        if (e.target.value === "") {
                            onDocumentChange(doc._id, "periodicity", 0)
                        }
                    }}
                />

                <span className="labelHolder">Month(s)</span>
            </div>

            <div className="inputContainer">
                <Dropdown>
                    <Dropdown.Toggle className={`${doc.country ? "" : "default"}`}>
                        {doc.country ? countryInformation.find(c => c.code === doc.country).country : "Select country"}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        {countryInformation.map((information) => (
                            <Dropdown.Item
                                key={information.code}
                                onClick={() => onDocumentChange(doc._id, "country", information.code)}
                            >
                                {information.country}
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
            </div>

            <div className="inputContainer">
                <Dropdown>
                    <Dropdown.Toggle className={`${doc.typePerson ? "" : "default"}`}>
                        {doc.typePerson ? doc.typePerson : "Select option"}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        {countryInformation.find(c => c.code === doc.country)?.typePersonValues.map((person, index) => (
                            <Dropdown.Item
                                key={index}
                                onClick={() => onDocumentChange(doc._id, "typePerson", person)}
                            >
                                {person}
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
            </div>

            <div className="inputContainer">
                <input
                    type="text"
                    value={doc.documentDisclaimer}
                    placeholder="document disclaimer"
                    onChange={(e) => onDocumentChange(doc._id, "documentDisclaimer", e.target.value)}
                />
            </div>

            <div className="inputContainer">
                <input
                    type="text"
                    value={doc.urlDownload ?? ""}
                    placeholder="Url to download document"
                    onChange={(e) => onDocumentChange(doc._id, "urlDownload", e.target.value)}
                />
            </div>

            <div className="inputContainer">
                <div
                    className={`toggleContainer ${doc.notApplicable ? "active" : ""}`}
                    onClick={() => onDocumentChange(doc._id, "notApplicable", !doc.notApplicable)}
                >
                    <div className="toggle"></div>
                </div>
            </div>

            <div className="inputContainer">
                <div
                    className={`toggleContainer ${doc.supplierCompliancy ? "active" : ""}`}
                    onClick={() => onDocumentChange(doc._id, "supplierCompliancy", !doc.supplierCompliancy)}
                >
                    <div className="toggle"></div>
                </div>
            </div>
        </div>
    )
}

const DocumentAccordionItem = ({ doc, index, onDocumentChange }) => {
    return (
        <Accordion.Item eventKey={String(index)}>
            <Accordion.Header>{doc.documentName || "New document"}</Accordion.Header>
            <Accordion.Body>
                <div className="inputContainer">
                    <span className="label">Document Name</span>
                    <input
                        type="text"
                        placeholder="Document name"
                        value={doc.documentName}
                        onChange={(e) => onDocumentChange(doc._id, "documentName", e.target.value)}
                    />
                </div>
                <div className="inputContainer">
                    <span className="label">Periodicity</span>
                    <input
                        type="number"
                        value={doc.periodicity ?? ""}
                        onChange={(e) => {
                            const raw = e.target.value
                            onDocumentChange(doc._id, "periodicity", raw === "" ? "" : Math.max(0, Math.round(Number(raw))))
                        }}
                        onBlur={(e) => {
                            if (e.target.value === "") {
                                onDocumentChange(doc._id, "periodicity", 0)
                            }
                        }}
                    />
                    <span className="labelHolder">Month(s)</span>
                </div>
                <div className="inputContainer">
                    <span className="label">Country</span>
                    <Dropdown>
                        <Dropdown.Toggle className={`${doc.country ? "" : "default"}`}>
                            {doc.country ? countryInformation.find(c => c.code === doc.country).country : "Select country"}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {countryInformation.map((information) => (
                                <Dropdown.Item
                                    key={information.code}
                                    onClick={() => onDocumentChange(doc._id, "country", information.code)}
                                >
                                    {information.country}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <div className="inputContainer">
                    <span className="label">Type of person</span>
                    <Dropdown>
                        <Dropdown.Toggle className={`${doc.typePerson ? "" : "default"}`}>
                            {doc.typePerson ? doc.typePerson : "Select option"}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {countryInformation.find(c => c.code === doc.country)?.typePersonValues.map((person, pIndex) => (
                                <Dropdown.Item
                                    key={pIndex}
                                    onClick={() => onDocumentChange(doc._id, "typePerson", person)}
                                >
                                    {person}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <div className="inputContainer">
                    <span className="label">Document disclaimer</span>
                    <input
                        type="text"
                        value={doc.documentDisclaimer}
                        placeholder="document disclaimer"
                        onChange={(e) => onDocumentChange(doc._id, "documentDisclaimer", e.target.value)}
                    />
                </div>
                <div className="inputContainer">
                    <span className="label">Url to download document</span>
                    <input
                        type="text"
                        value={doc.urlDownload ?? ""}
                        placeholder="Url to download document"
                        onChange={(e) => onDocumentChange(doc._id, "urlDownload", e.target.value)}
                    />
                </div>
                <div className="inputContainer">
                    <span className="label">Optional</span>
                    <div
                        className={`toggleContainer ${doc.notApplicable ? "active" : ""}`}
                        onClick={() => onDocumentChange(doc._id, "notApplicable", !doc.notApplicable)}
                    >
                        <div className="toggle"></div>
                    </div>
                </div>
                <div className="inputContainer">
                    <span className="label">Required</span>
                    <div
                        className={`toggleContainer ${doc.supplierCompliancy ? "active" : ""}`}
                        onClick={() => onDocumentChange(doc._id, "supplierCompliancy", !doc.supplierCompliancy)}
                    >
                        <div className="toggle"></div>
                    </div>
                </div>
            </Accordion.Body>
        </Accordion.Item>
    )
}

export default function UniqueDocsByClient() {
    const { user } = useAuth()
	const userLogged = user?.selectedProfile
    const darkLightMode = userLogged?.darkLightMode

    const {
        uniqueDocs,
        handleDocumentChange,
        addNewDocument,
        discardChanges,
        hasPendingChanges,
        canSave,
        handleSaveChanges,
    } = useUniqueDocs()
    
    return (
        <section className={`uniqueDocsByClient ${darkLightMode ? "darkMode" : null}`}>
            <h3>Unique Docs By Client</h3>

        <div className="d-none d-lg-block">
                <TableHeader />

                <div className="tableBody">
                    {uniqueDocs?.map((doc) => {
                        return (
                            <DocumentRow key={doc._id} doc={doc} onDocumentChange={handleDocumentChange} />
                        )
                    })}

                    <button
                        className="btnBgBlueTextGradient addDocument"
                        onClick={addNewDocument}
                    />
                </div>
            </div>

            <div className="mobileView d-lg-none">
                <div className="mobileHeader">
                    <h5>Documents</h5>
                    <button
                        className="btnBgBlueTextGradient addDocument"
                        onClick={addNewDocument}
                    />
                </div>
                <Accordion>
                    {uniqueDocs?.map((doc, index) => (
                        <DocumentAccordionItem
                            key={doc._id}
                            doc={doc}
                            index={index}
                            onDocumentChange={handleDocumentChange}
                        />
                    ))}
                </Accordion>
            </div>

            <div className="actions">
                <button 
                    className="btnBgBlueTextGradient" 
                    onClick={discardChanges}
                    disabled={!hasPendingChanges}
                >
                    Discard changes
                </button>

                <button 
                    className="btnBgBlueTextGradient"
                    disabled={!canSave}
                    onClick={handleSaveChanges}
                >
                    Save changes
                </button>
            </div>
        </section>
    )
}
